export default "__VITE_PUBLIC_ASSET__a76a8f0b__"